module.exports = __webpack_public_path__ + "pc/img/rec_08.a788bb4a.svg";